import { useState } from 'react';
import { DatasetDetailView, DatasetDetailTab } from '@/UI/Simulation/components/DatasetDetailView';
import { DatasetListView } from '@/UI/Simulation/components/DatasetListView';
import { RunDetailView } from '@/UI/Simulation/components/RunDetailView';

export const SimulationPage = () => {
  const [selectedDatasetId, setSelectedDatasetId] = useState<number | null>(null);
  // Tracked alongside selectedDatasetId so the run-detail breadcrumb can show
  // the parent dataset's name without re-fetching the dataset by run id.
  const [selectedDatasetName, setSelectedDatasetName] = useState<string>('');
  const [selectedRunId, setSelectedRunId] = useState<number | null>(null);
  // Which tab to land on when we render DatasetDetailView. Flipped to 'runs'
  // when the user opens a run, so coming back from a run preserves context.
  const [datasetTab, setDatasetTab] = useState<DatasetDetailTab>('messages');

  const openRun = (runId: number) => {
    setDatasetTab('runs');
    setSelectedRunId(runId);
  };

  const openDataset = (datasetId: number) => {
    setDatasetTab('messages');
    setSelectedDatasetId(datasetId);
  };

  const closeRun = () => setSelectedRunId(null);

  const closeAll = () => {
    setSelectedRunId(null);
    setSelectedDatasetId(null);
    setSelectedDatasetName('');
  };

  if (selectedRunId && selectedDatasetId) {
    return (
      <div data-testid="simulation-page-run-detail">
        <RunDetailView
          runId={selectedRunId}
          datasetName={selectedDatasetName}
          onBackToDataset={closeRun}
          onBackToList={closeAll}
        />
      </div>
    );
  }

  if (selectedDatasetId) {
    return (
      <div data-testid="simulation-page-dataset-detail">
        <DatasetDetailView
          datasetId={selectedDatasetId}
          initialTab={datasetTab}
          onBack={() => {
            setSelectedDatasetId(null);
            setSelectedDatasetName('');
          }}
          onViewRun={openRun}
          onDatasetLoaded={setSelectedDatasetName}
        />
      </div>
    );
  }

  return (
    <div data-testid="simulation-page-dataset-list">
      <DatasetListView onSelect={openDataset} />
    </div>
  );
};
